<template>
  <phoenix-wrapper>

    <div class="content-page w-full" v-if="!loading">
      <h2 class="my-5">Verify Income</h2>

      <p style="max-width: 320px; color: #858585">
        Once your income is verified and approved, you will get funded within 24 hours.
      </p>

      <DesiredLoan :amount="loan.amount | money(0)"/>
      <br/>
      <PhoenixBoxAction
          @click="handlePlaid()"
          label="Verify"
          appareance="instant-connection"
      />

      <div class="if-loading" v-if="loading">
        <div class="inside-container-1 flex flex-col w-full sm:w-317 mx-auto">
          <h2 class="text-center text-2xl md:text-4xl">Verifying Income</h2>
          <p class="text-center my-4">Please wait while we verify your income.</p>
        </div>
      </div>
    </div>
  </phoenix-wrapper>
</template>

<script>
import BoxAction from "../../../../aurora/components/AuroraBoxAction.vue";
import DesiredLoan from "../../../../../components/DesiredLoan.vue";
import PhoenixBoxAction from "../../../components/PhoenixBoxAction.vue";

export default {
  mixins: [
    require("../../../../../mixins/InteractsWithGtag").default,
    require("../../../../../mixins/VerifyMethods").default,
  ],
  components: {
    PhoenixBoxAction,
    DesiredLoan,
    BoxAction,
  },
  props: {
    user: {},
    loan: {},
    manual: {
      type: Boolean,
      default: false,
    },
    plaidLinkToken: {},
  },

  data() {
    return {
      gTagPageName: "income-verification",
      plaid: null,
      loading: false,
    };
  },

  methods: {
    refresh() {
      window.location.reload();
    },

    handlePlaid() {
      this.loading = true;
      this.plaid = window.Plaid.create({
        token: this.plaidLinkToken,
        onSuccess: () => {
          this.loading = true;

          this.$http.post(`/signup/welcome/${this.loan.id}`, {
            income_verification_submitted: true,
          }).then(() => {
            this.loading = false;

            this.proceed();
          }).catch(error => {
            this.loading = false;
          })
        },
        onEvent: (event, metadata) => {
            if (event == 'ERROR') {
                window.Bugsnag.notify('fail PhoenixIncomeVerification: ' + JSON.stringify({
                  error: metadata.error_code + ' (' + metadata.error_message + ')',
                  loan_id: this.loan?.id,
                  user_id: this.user?.id,
                }));
            }

            this.$http?.post('/api/plaid/link-events', {
                event_name: event,
                loan_id: this.loan?.id ?? null,
                institution_name: metadata.institution_name ?? metadata.institution?.name ?? null,
                error_type: metadata.error_type ?? null,
                error_code: metadata.error_code ?? null,
                error_message: metadata.error_message ?? null,
                link_session_id: metadata.link_session_id ?? null,
                request_id: metadata.request_id ?? null,
                exit_status: metadata.exit_status ?? null,
                metadata: metadata,
                event_time: new Date().toISOString(),
            }).catch(() => {});
        },
        onExit: (error, metadata) => {
          this.loading = false;
        },
      });
      this.plaid.open();
    },

    proceed() {
      this.gTagEvent(`verified`, {
        event_category: 'onboarding',
        event_label: 'income',
      });

      window.location.href = `/account/loans/${this.loan.id}`;
    },
  },
};
</script>
